import { render } from "./YRichtext.vue?vue&type=template&id=6cbfbb5a&scoped=true"
import script from "./YRichtext.vue?vue&type=script&lang=js"
export * from "./YRichtext.vue?vue&type=script&lang=js"

import "./YRichtext.vue?vue&type=style&index=0&id=6cbfbb5a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbfbb5a"]])

export default __exports__